import React, { Component } from "react";
import { IStore } from "@my-dld/reducers/store";
import { connect } from "react-redux";
import { FolderItem } from "./api/entities";
import { dispatch } from "@my-dld/utils/StoreUtils";
import { VaultActions } from "./actions";

export interface VaultData {
	refId?: string;
	searchResult?: FolderItem;
}

export interface IVaultDataContext extends VaultData {
}

export const defaultContext: IVaultDataContext = {} as IVaultDataContext;
export const VaultContext = React.createContext( defaultContext );


interface Props extends IVaultDataContext {

}

class VaultContextWrapper extends Component<Props> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			...defaultContext,
		};
	}


	render() {
		const { children, ...props } = this.props;
		return <VaultContext.Provider value={ props }>
			{ children }
		</VaultContext.Provider>;
	}
}

const mapStateToProps = ( state: IStore ): IVaultDataContext => {
	return {
		...state.Vault,
	};
};

export default connect( mapStateToProps )( VaultContextWrapper );

declare module "@my-dld/reducers/store" {
	interface IStore {
		Vault: IVaultDataContext,
	}
}

export function updateVault( data: Partial<VaultData> ) {
	dispatch( VaultActions.UPDATE_VAULT, data );
}
